import { TextField as MuiTextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { Fragment } from 'react';
import { useFormContext } from '../../contexts/FormContext';
import { isValidNumberInput } from '../../utils/utils';

const NumberField = ({ field }: { field: any }) => {
  const { formData, getFormDataItem, handleChange } = useFormContext();

  let isHidden = field.hasOwnProperty('isHidden') ? getFormDataItem(formData, field?.isHidden) : false;

  if (field.hasOwnProperty('revertHidden') && field?.revertHidden) {
    isHidden = !isHidden;
  }

  if (isHidden) {
    return null;
  }

  const handleNumberChange = (e: any) => {
    const value = e.target.value;

    if (isValidNumberInput(value)) {
      handleChange(e, field);
    }
  };

  const label = field.hasOwnProperty('help') ? (
    <Fragment>
      {field.label}
      <ChartHelpTooltip chartType={field.help} type="label" />
    </Fragment>
  ) : (
    field.label
  );

  return (
    <Grid size={field.size || 12} key={field.name}>
      <MuiTextField
        error={field.error || false}
        label={label}
        fullWidth
        required={field.required || false}
        disabled={field.hasOwnProperty('disabled') ? getFormDataItem(formData, field?.disabled) : false}
        inputProps={{
          min: field.min || null,
          max: field.max || null,
        }}
        type="text"
        name={field.name}
        value={getFormDataItem(formData, field.name)}
        onChange={handleNumberChange}
      />
    </Grid>
  );
};

export default NumberField;
